/* @ngInject */
export default function RcuManagementService($q, $sails, $log) {
  const service = this;

  service.getData = getData;
  service.getRcuData = getRcuData;
  service.clearQueues = clearQueues;


  function sailsGet(url) {
    return $sails.get(url)
      .then(res => res.body);
  }

  // currently just returns a big object, eventually will $http and get the user info for hteir user_id
  function getData() {
    return sailsGet('/jobServer/getData')
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getRcuData() {
    return sailsGet('/jobServer/getRcuData')
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function clearQueues(queues) {
    return $sails.post('/jobServer/clearQueues', { jobs: queues })
      .then(res => res.body)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }
}
